import React, { useCallback, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import * as Yup from 'yup';
import { toast } from 'react-toastify';

import api from '../../../../services/api';
import history from '../../../../services/history';

import { AppError } from '../../../../errors/AppError';
import { getCatalogo } from '../../../../lib/asyncUtils';

import { Form, FormWrapper } from '../../../../components/Form';
import AsyncSelect from '../../../../components/Form/Input/AsyncSelect';
import TitleBar from '../../../../components/TitleBar';

const schema = Yup.object().shape({
  idCatalogo: Yup.number()
    .typeError('O campo "Catálogo" é obrigatório')
    .required('O campo "Catálogo" é obrigatório'),
});

function EmpresaCatalogoCriar() {
  const location = useLocation();
  const { idEmpresa } = location.state;

  const formRef = useRef(null);

  const handleConfirmar = useCallback(
    async (data) => {
      try {
        await schema.validate(data, {
          abortEarly: false,
        });

        const { idCatalogo } = data;

        await api.post(`empresa/${idEmpresa}/catalogo/${idCatalogo}`);

        toast.success('Relacionamento cadastrado com sucesso!');
      } catch (err) {
        AppError(err, formRef);
      }
    },
    [idEmpresa]
  );

  return (
    <>
      <TitleBar back={!!location.background} title="Novo Relacionamento" />
      <FormWrapper>
        <Form
          id="formEmprCatalogo"
          ref={formRef}
          onSubmit={handleConfirmar}
          autoComplete="off"
        >
          <Form.Column>
            <Form.Row>
              <AsyncSelect
                id="idCatalogo"
                name="idCatalogo"
                label="Catalogo"
                cacheOptions
                defaultOptions
                loadOptions={getCatalogo}
                width={800}
              />
            </Form.Row>
          </Form.Column>
          <Form.Separate withFlex />
          <Form.Footer>
            <button
              id="btn-cancel"
              type="button"
              onClick={() => history.goBack()}
            >
              Cancelar
            </button>
            <button id="btn-submit" type="submit" form="formEmprCatalogo">
              Confirmar
            </button>
          </Form.Footer>
        </Form>
      </FormWrapper>
    </>
  );
}

export { EmpresaCatalogoCriar };
